export const DASHBOARD_PENDING_EXPENSE_STATUSES = ["pending", "pending_invoicing"] as const;

export type ExpenseStatusFilter = {
  status?: string;
  statuses?: readonly string[];
};

/** Applies the exact status predicate shared by the dashboard queue and Finance list. */
export function filterExpensesByStatus<T extends Record<string, any>>(
  expenses: readonly T[],
  filter: ExpenseStatusFilter = {},
): T[] {
  if (filter.statuses !== undefined) {
    const statuses = new Set(filter.statuses);
    return expenses.filter((expense) => statuses.has(expense.status));
  }
  if (filter.status !== undefined) {
    return expenses.filter((expense) => expense.status === filter.status);
  }
  return [...expenses];
}
